import { useState } from 'react';

const useModal = (initialValue = false) => {
    const [isOpenModal, setIsOpenModal] = useState(initialValue);

    const closeModal = () => {
        document.getElementsByTagName('body')[0].style.overflow = 'visible';
        setIsOpenModal(false);
    };
    const openModal = () => {
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
        setIsOpenModal(true);
    };
    return [isOpenModal, closeModal, openModal];
};

export default useModal;
